module.exports = __webpack_public_path__ + "img/cooperation_unit_01.47d74c33.png";